import HTTP from '@/utils/http'

export async function getKey (number = 1) {
  try {
    const response = await HTTP.get(`/common/key?number=${number}`)
    return response.data.data
  } catch (err) {
    throw err
  }
}
